import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEs from '../locales/es/common.json';
import commonEn from '../locales/en/common.json';

const LANGUAGE_STORAGE_KEY = 'language';
const USER_SETTINGS_STORAGE_KEY = 'userSettings';

export const normalizeLanguage = (language) => {
  const value = (language || '').toLowerCase();
  return value.startsWith('en') ? 'en' : 'es';
};

// eslint-disable-next-line no-unused-vars
const getStoredLanguage = () => {
  try {
    const userSettingsRaw = localStorage.getItem(USER_SETTINGS_STORAGE_KEY);
    if (userSettingsRaw) {
      const userSettings = JSON.parse(userSettingsRaw);
      if (userSettings?.language) {
        return normalizeLanguage(userSettings.language);
      }
    }

    const directLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (directLanguage) {
      return normalizeLanguage(directLanguage);
    }
  } catch (error) {
    // Silently ignore
  }

  const browserLanguage =
    (Array.isArray(navigator.languages) && navigator.languages[0]) || navigator.language || 'es';
  return normalizeLanguage(browserLanguage);
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        es: {
          common: commonEs,
        },
        en: {
          common: commonEn,
        },
      },
      // Por ahora forzamos español en toda la app — la UI de selección de
      // idioma se sacó. Dejamos getStoredLanguage() en código pero sin uso
      // por si después queremos volver a habilitar la selección.
      lng: 'es',
      fallbackLng: 'es',
      supportedLngs: ['es', 'en'],
      defaultNS: 'common',
      ns: ['common'],
      keySeparator: false,
      nsSeparator: false,
      interpolation: {
        escapeValue: false,
      },
      returnNull: false,
    });
}

i18n.on('languageChanged', (language) => {
  try {
    const normalizedLanguage = normalizeLanguage(language);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);

    // Keep user settings in sync to avoid language mismatch between stores.
    const userSettingsRaw = localStorage.getItem(USER_SETTINGS_STORAGE_KEY);
    const userSettings = userSettingsRaw ? JSON.parse(userSettingsRaw) : {};
    localStorage.setItem(
      USER_SETTINGS_STORAGE_KEY,
      JSON.stringify({
        ...userSettings,
        language: normalizedLanguage,
      })
    );

    // Reflect the active language on the <html lang> attribute so screen readers
    // and search engines see the right language, and CSS :lang(...) selectors work.
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.lang = normalizedLanguage;
    }
  } catch (error) {
    // Silently ignore
  }
});

// Initial sync — covers the case where the page boots in the user's preferred
// language without firing a `languageChanged` event.
if (typeof document !== 'undefined' && document.documentElement) {
  document.documentElement.lang = normalizeLanguage(i18n.language);
}

export default i18n;
